import React, { FunctionComponent } from "react";

import { useSearchPartPackagesByVehicle } from "../../../queries/useSearchPartPackagesByVehicle";
import { useProductModalHash } from "../ProductModal";
import { PackageDetails } from "./PackageDetails";

export const PackageModalContent: FunctionComponent = () => {
  const { data: results } = useSearchPartPackagesByVehicle();
  const { itemId } = useProductModalHash();

  const product = results?.find(
    ({ partDetails }) => partDetails.primaryPart.itemId === itemId
  );

  return <PackageDetails part={product || null} />;
};
